import React, { createContext, ReactNode, useEffect, useMemo, useRef, useState } from 'react';
import { addressesSelector } from 'core/store/addresses/selectors';
import { authGetCustomerSelector } from 'core/store/auth/selectors';
import { useAppSelector } from 'core/store/store.utils';
import { initializeInsiderQueue, insertInsiderScript } from 'shared/utils/insider.utils';

interface IInsiderContext {
  insiderIsReady: boolean;
}

export const InsiderContext = createContext<IInsiderContext>({
  insiderIsReady: false,
});

export const useInsider = () => React.useContext(InsiderContext);

export interface IInsiderProviderProps {
  children: ReactNode;
}

export const InsiderProvider = ({ children }: IInsiderProviderProps) => {
  const [insiderIsReady, setInsiderIsReady] = useState(false);
  const customer = useAppSelector(authGetCustomerSelector);
  const { addresses } = useAppSelector(addressesSelector);
  const customerId = customer?.id;
  const isInitialized = useRef(false);

  useEffect(() => {
    const initializeInsiderUser = () => {
      if (customerId && customer) {
        isInitialized.current = true;
        initializeInsiderQueue();
        insertInsiderScript(status => {
          setInsiderIsReady(status);
        });
      }
    };
    if (!isInitialized.current) initializeInsiderUser();
  }, [customerId, customer, addresses, insiderIsReady]);

  const value = useMemo(
    () => ({
      insiderIsReady,
    }),
    [insiderIsReady],
  );

  return <InsiderContext.Provider value={value}>{children}</InsiderContext.Provider>;
};
